import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer-container" }
const _hoisted_2 = { class: "footer-menu" }
const _hoisted_3 = { class: "bottom-container" }
const _hoisted_4 = { class: "copyright" }
const _hoisted_5 = ["src"]

import { ref } from 'vue';
import beepalletLogo from '@/assets/images/BeePallet_Logo_Black.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const menuFooter = ref([
	{ id: 1, label: 'Política de privacidad', link: 'privacy_policy' },
	{ id: 2, label: 'Condiciones del servicio', link: 'terms_conditions' },
	{ id: 3, label: 'Política de Cookies', link: 'cookies_policy' }
]);

const currentYear = new Date().getFullYear();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"rrss\" data-v-70f34e93><a href=\"https://www.linkedin.com/company/105811041\" target=\"_blank\" class=\"rrss_btn linkedin\" alt=\"Linkedin\" data-v-70f34e93></a><a href=\"https://x.com/PressBeePallet\" target=\"_blank\" class=\"rrss_btn twitter\" alt=\"Twitter\" data-v-70f34e93></a></div><nav class=\"footer-menu no-margin\" data-v-70f34e93><a href=\"https://beepallet.com/blog/sobre-nosotros/\" class=\"menu-btn\" target=\"_blank\" rel=\"noopener\" data-v-70f34e93>Sobre nosotros</a><a href=\"https://beepallet.com/blog/contacto/\" class=\"menu-btn\" target=\"_blank\" rel=\"noopener\" data-v-70f34e93>Contáctanos</a></nav>", 2)),
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuFooter.value, (menuItem) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: menuItem.id,
          to: { name: menuItem.link }
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(menuItem.label), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128)),
      _createVNode(_component_router_link, {
        to: "/sitemap.xml",
        target: "_blank",
        rel: "noopener"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Sitemap")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, "COPYRIGHT ® " + _toDisplayString(_unref(currentYear)) + " BeePallet - Todos los derechos reservados.", 1),
      _createElementVNode("img", {
        src: _unref(beepalletLogo),
        alt: "Logo BeePallet"
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})